'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["property", "onInsert", "fetchPaths", "dataTokenConfig"];
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIFieldset from 'UIComponents/form/UIFieldset';
import PopoverContent from 'data-token-picker/components/PopoverContent';
import { usePaths } from '../personalize/hooks/usePaths';
import { RequestStatus } from '../../api/constants';
import { jsx as _jsx } from "react/jsx-runtime";
function DataTokenPopoverBodyInsert(_ref) {
  let {
      property,
      onInsert,
      fetchPaths,
      dataTokenConfig
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const settingsLink = dataTokenConfig.isEmail ? rest.emailSettingsLink : rest.publishingSettingsLink;
  const {
    category,
    field,
    subCategory
  } = property || {};
  const [{
    categories,
    fieldsByCategory
  }, pathsRequestStatus] = usePaths(fetchPaths, dataTokenConfig);
  const allowEmptyFallbacks = dataTokenConfig.allowEmptyFallbacks === undefined ? true : dataTokenConfig.allowEmptyFallbacks;
  const propertiesLoading = pathsRequestStatus === RequestStatus.PENDING || pathsRequestStatus === RequestStatus.UNINITIALIZED;
  if (propertiesLoading) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      className: "medium-popover-body",
      layout: "centered",
      minHeight: 300
    });
  }
  return /*#__PURE__*/_jsx(UIFieldset, {
    _size: "small",
    children: /*#__PURE__*/_jsx(PopoverContent, Object.assign({
      className: "medium-popover-body m-y-5 p-x-6",
      category: category,
      categories: categories,
      field: subCategory ? `${field}.${subCategory}` : field,
      fieldsByCategory: fieldsByCategory,
      allowEmptyFallbacks: allowEmptyFallbacks,
      hideFallbacks: dataTokenConfig && dataTokenConfig.hideFallbacks,
      onConfirm: onInsert,
      settingsLink: settingsLink
    }, rest))
  });
}
DataTokenPopoverBodyInsert.displayName = 'DataTokenPopoverBodyInsert';
export default DataTokenPopoverBodyInsert;